import {useState, useCallback} from 'react';
import {useRecoilCallback} from 'recoil';
import {useNavigate} from 'react-router-dom';
import {MyPaymentsEnum, OperationStateTypesEnum} from 'presentation/constants';
import {makePostElectronicBill} from 'main/factories/usecases/private/my-payments-flow/remote-my-payments/post-electronic-bill';
import {useSubscriptionDialogsStateStore} from 'presentation/components/SubscriptionDialogs/store/useSubscriptionDialogsStateStore';
import {useAccountDataStore} from '../store/useAccountDataStateStore';

export const useElectronicBillSubscription = () => {
	const [protocol, setProtocol] = useState<string | null>(null);
	const {accesses} = useAccountDataStore(state => state.accountData);
	const setAccountData = useAccountDataStore(state => state.setAccountData);

	const isSubscribed = accesses?.accessElectronicBill;
	const hasFinancialAcess = accesses?.financial;
	const navigate = useNavigate();
	const setDialogs = useSubscriptionDialogsStateStore(state => state.updateState);
	const dialogs = useSubscriptionDialogsStateStore(state => state.state);

	const [operationState, setOperationState] = useState(OperationStateTypesEnum.NONE);

	const isSubmitting = operationState === OperationStateTypesEnum.SUBMITTING;

	const handleSubscriptionResponse = useRecoilCallback(
		() => async () => {
			try {
				const postElectronicBill = makePostElectronicBill();
				const response = await postElectronicBill?.post();
				if (response?.protocolo) {
					setProtocol(response.protocolo);
					setDialogs({
						isSubscriptionModalOpen: false,
						isSubscriptionErrorModalOpen: false,
						isSubscriptionSucessModalOpen: true,
					});
				}
			} catch (error) {
				setDialogs({
					isSubscriptionErrorModalOpen: true,
					isSubscriptionModalOpen: false,
				});
			}
		},
		[setDialogs],
	);

	const handleToggleSubscriptionModal = useCallback(
		(isOpen: boolean) => {
			setDialogs({
				isSubscriptionModalOpen: isOpen,
			});
		},
		[setDialogs],
	);

	const handleCloseSubscriptionSucessModal = useCallback(async () => {
		setDialogs({
			isSubscriptionSucessModalOpen: false,
			isSubscriptionModalOpen: false,
		});
		try {
			setAccountData({
				accesses: {
					...accesses,
					accessElectronicBill: true,
				},
			});
			const currentPath = window.location.pathname;
			if (currentPath !== MyPaymentsEnum.OPEN_BILLS) {
				navigate(MyPaymentsEnum.OPEN_BILLS);
			}
		} catch (error) {
			setDialogs({
				isSubscriptionSucessModalOpen: false,
				isSubscriptionModalOpen: false,
				isSubscriptionErrorModalOpen: true,
			});
		}
	}, [setDialogs, setAccountData, navigate]);

	const handleToggleShowInfoModal = useCallback(
		(isOpen: boolean) => {
			setDialogs({
				isSubscriptionInfoModalOpen: isOpen,
			});
		},
		[setDialogs],
	);

	return {
		isSubscriptionModalOpen: dialogs.isSubscriptionModalOpen,
		isSubscriptionSucessModalOpen: dialogs.isSubscriptionSucessModalOpen,
		isSubscriptionErrorModalOpen: dialogs.isSubscriptionErrorModalOpen,
		isSubscriptionInfoModalOpen: dialogs.isSubscriptionInfoModalOpen,
		protocol,
		handleSubscriptionResponse,
		handleCloseSubscriptionSucessModal,
		isSubscribed,
		hasFinancialAcess,
		handleToggleSubscriptionModal,
		handleToggleShowInfoModal,
		setOperationState,
		isSubmitting,
	};
};
